import { WASTE_BASE_PATH } from '@waste/routes/Routes';
import { Link } from 'react-router-dom';

export const TestLandingPage = () => {
  return (
    <main>
      <div className="flex flex-col gap-x-2">
        <section>
          <ul>
            <li>
              <Link to={`${WASTE_BASE_PATH}?type=bin_bags`}>Bin bags</Link>
            </li>
            <li>
              <Link to={`${WASTE_BASE_PATH}?type=bins`}>Bins</Link>
            </li>
            <li>
              <Link to={`${WASTE_BASE_PATH}?type=cardboard_boxes`}>
                Cardboard boxes
              </Link>
            </li>
            <li>
              <Link to={`${WASTE_BASE_PATH}?type=dead_animals`}>
                Dead animals
              </Link>
            </li>
            <li>
              <Link to={`${WASTE_BASE_PATH}?type=dog_poo`}>Dog poo</Link>
            </li>
            <li>
              <Link to={`${WASTE_BASE_PATH}?type=dumped_rubbish`}>
                Dumped rubbish
              </Link>
            </li>
            <li>
              <Link
                to={`${WASTE_BASE_PATH}?type=graffiti_posters_and_stickers`}
              >
                Graffiti, posters and stickers
              </Link>
            </li>
            <li>
              <Link to={`${WASTE_BASE_PATH}?type=litter`}>Litter</Link>
            </li>
            <li>
              <Link to={`${WASTE_BASE_PATH}?type=street_cleaning`}>
                Street cleaning
              </Link>
            </li>
          </ul>
        </section>
      </div>
    </main>
  );
};
